import Contents from "../contents";
import {prefixed, defer} from "../utils/core";
import { EVENTS, DOM_EVENTS, BODY_EVENTS, MEDIA_EVENT } from "./utils/constants";
import ExEpubCFI from "./epubcfi";
import ExMapping from "./mapping";

const hasNavigator = typeof (navigator) !== "undefined";
const isChrome = hasNavigator && /Chrome/.test(navigator.userAgent);
const isWebkit = hasNavigator && !isChrome && /AppleWebKit/.test(navigator.userAgent);

const ELEMENT_NODE = 1;

class ExContents extends Contents{
	constructor(doc, content, cfiBase, sectionIndex, rendition){
		super(doc, content, cfiBase, sectionIndex);

		let booksWritingMode = rendition.themes._booksWritingMode;
		if(rendition.book.templateInfo.isTemplate){
			if(booksWritingMode !== "initial"){
				$(".vrtl, .hltr", doc).each((index, element) => {
					$(element).removeClass("vrtl hltr");
					switch(booksWritingMode){
						case 'horizontal': $(element).addClass("hltr");
											break;
						case 'vertical': $(element).addClass("vrtl");
										 break;
					}
				});
				
			}
		}

		//於捲動瀏覽時移除audio標籤
		if(rendition.manager.name === "continuous" && rendition.settings.removeAudioOnContinuous){
			if(rendition.settings.replaceAudioImage && rendition.settings.replaceAudioImage !== ""){
				$(".books-audio-fake-image",doc).each((index, audio) => {
					$(audio).remove();
				});
			}else{
				$("audio",doc).each((index, audio) => {
					$(audio).remove();
				});
			}
		}

		//置換ExEpubCFI
		this.epubcfi = new ExEpubCFI();

		//加入rendition
		this._rendition = rendition;

		//目前章節未載入影片數量
		this._videos = [];
		this._unloadVideoNum = 0;
		this._videoOnload = false;

		//目前章節未載入圖片數量
		this._images = [];
		this._nowLoadIMgIndex = null;
		this._unloadImgNum = 0;
		this._imgOnload = false;

		//內容就緒延遲
		this._allContentOnloadDefer = new defer();

		//目前章節未載入style
		this._unloadStyleNum = (this._rendition._layout.name === "pre-paginated") ? 1 : 2;
		this._styleOnload = false;
		this._fontOnload = false;

		//呼叫 newListeners
		this.newListeners();

		//加入監聽後的初始化
		this.afterListenersInit();

		//是否已發生contextmenu
		this.isContentMenu = false;

		//最後尺寸就緒延遲
		this._finalContentSizeDefer = new defer();
		this._isGetFinalContentSize = false;

		//目前backgroundSize
		this._backgroundSize = {
			width:0,
			height:0
		};

		//上次編輯範圍
		this._preSelectRange = null;
	}

	//加入監聽後初始化
	afterListenersInit(){
		if(!this.document) {
			return;
		}

		//初始化影片全屏播放模式
		this._rendition.manager._isMediaFullScreen = false;

		//初始化撥放狀態
		$("audio, video", this.document).each((index, media) => {
			$(media).attr("data-is-playing", "no");
		});

		//讓影片開始載入, 不然safari會沒有畫面
		$("video", this.document).each((index, video) => {
			video.load();
		});

		
		
	}

	/**
	 * Add DOM listeners
	 * @private
	 */
	listeners() {
		// replace by newListeners 
	}
	newListeners(){
		this.imageLoadListeners();

		this.videoLoadListeners();

		this.mediaQueryListeners();

		this.fontLoadListeners();

		this.addEventListeners();

		this.addSelectionListeners();

		// this.transitionListeners();

		if (typeof ResizeObserver === "undefined") {
			this.resizeListeners();
			this.visibilityListeners();
		} else {
			this.resizeObservers();
		}

		// this.mutationObservers();

		this.linksHandler();
	}

	/**
	 * Use ResizeObserver to listen for changes in the DOM and check for resize
	 * @private
	 */
	 resizeObservers() {

		//因 ios 和 safari 有 
		//ResizeObserver loop completed with undelivered notifications. 
		//ResizeObserver loop limit exceeded
		//所以取消 ResizeObserver 物件
		/*
		// create an observer instance
		this.observer = new ResizeObserver((e) => {
			requestAnimationFrame(this.resizeCheck.bind(this));
		});

		// pass in the target node
		this.observer.observe(this.document.documentElement);
		*/
	}

	/**
	 * Poll for resize detection
	 * @private
	 */
	resizeListeners() {
		var width, height;
		// Test size again
		clearTimeout(this.expanding);
		requestAnimationFrame(this.resizeCheck.bind(this));
		this.expanding = setTimeout(this.resizeListeners.bind(this), 350);
	}

	/**
	 * Add DOM event listeners
	 * @private
	 */
	 addEventListeners(){
		if(!this.document) {
			return;
		}

		this._triggerEvent = this.triggerEvent.bind(this);

		DOM_EVENTS.forEach(function(eventName){
			switch (eventName){
				case 'wheel':
				case 'mousewheel':
				case 'DOMMouseScroll': this.document.addEventListener(eventName, this._triggerEvent, { passive: false });
									   break;
				default: this.document.addEventListener(eventName, this._triggerEvent, { passive: true });
			}
		}, this);

		//加入body事件
		BODY_EVENTS.forEach(function(eventName){
			this.content.addEventListener(eventName, this._triggerEvent);
		}, this);

		//加入media事件
		MEDIA_EVENT.forEach(function(eventName){
			$("audio, video", this.document).each((index, media) => {
				media.addEventListener(eventName, this._triggerEvent, { passive: true });
			});
		}, this);

		// 手勢事件
		this._eventPreventDefault = this.eventPreventDefault.bind(this);
		this.document.addEventListener("gesturestart", this._eventPreventDefault, true);
		this.document.addEventListener("gesturechange", this._eventPreventDefault, true);
		this.document.addEventListener("gestureend", this._eventPreventDefault, true);
		
		// 阻止鍵盤造成滾動
		this._preventScroll = this.preventScroll.bind(this);
		this.document.addEventListener("keydown", this._preventScroll, true);
	}

	eventPreventDefault(event){
		if(this._rendition.book.settings.encryptType && !this._rendition.settings.isDomTriggerByTouch){
			event.preventDefault();
		}
	}

	preventScroll(event){
		var keys = [32, 33, 34, 35, 37, 38, 39, 40];
		if (keys.includes(event.keyCode)) {
			event.preventDefault();
			return false;
		}
	}

	imageUnloadListeners() {
		var images = this.document.querySelectorAll("img");
		var img;
		for (var i = 0; i < images.length; i++) {
			img = images[i];
			img.onload = null;
			img.onresize = null;
			img.onerror = null;
			img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/5+hHgAHggJ/PchI7wAAAABJRU5ErkJggg==';
		}
	}

	videoUnloadListeners() {
		var videos = this.document.querySelectorAll("video");
		var video;
		for (var i = 0; i < videos.length; i++) {
			video = videos[i];
			video.onloadeddata = null;
			video.onerror = null;
		}
	}

	/**
	 * Remove DOM event listeners
	 * @private
	 */
	removeEventListeners(){
		if(!this.document) {
			return;
		}

		this.imageUnloadListeners();

		this.videoUnloadListeners();

		DOM_EVENTS.forEach(function(eventName){
			this.document.removeEventListener(eventName, this._triggerEvent, { passive: true });
		}, this);

		//加入body事件
		BODY_EVENTS.forEach(function(eventName){
			this.content.removeEventListener(eventName, this._triggerEvent);
		}, this);

		//加入media事件
		MEDIA_EVENT.forEach(function(eventName){
			$("audio, video", this.document).each((index, media) => {
				media.removeEventListener(eventName, this._triggerEvent, { passive: true });
			});
		}, this);

		// 阻止雙指放大
		this.document.removeEventListener("gesturestart", this._eventPreventDefault, true);
		this.document.removeEventListener("gesturechange", this._eventPreventDefault, true);
		this.document.removeEventListener("gestureend", this._eventPreventDefault, true);
		
		// 阻止鍵盤造成滾動
		this.document.removeEventListener("keydown", this._preventScroll, true);

		this._eventPreventDefault = undefined;
		this._preventScroll = undefined;
		this._triggerEvent = undefined;
	}

	/**
	 * Listen for font load and check for resize when loaded
	 * @private
	 */
	 fontLoadListeners() {
		if (!this.document || !this.document.fonts) {
			return;
		}

		this.document.fonts.ready.then(function () {
			this.resizeCheck();
		}.bind(this));

	}

	allContentOnloadCheck(){
		return this._allContentOnloadDefer.promise;
	}

	finalSizeCheck(){
		return this._finalContentSizeDefer.promise;
	}

	finalSizeResolveCheck(checkType){
		if(this.document){

			switch(checkType){
			case "video": if(this._unloadVideoNum === 0 && !this._videoOnload){
						  //console.log(this.sectionIndex + " total video onload");
						  this._videoOnload = true;
						 }
						 break;

			case "image": if(this._unloadImgNum === 0 && !this._imgOnload){
						   //console.log(this.sectionIndex + " total img onload");
						   this._imgOnload = true;
						  }
						  break;

			case "style": if(this._unloadStyleNum === 0 && !this._styleOnload){
						    //console.log(this.sectionIndex + " final style onload");
						    this._styleOnload = true;
							 this.document.fonts.ready.then(function () {
							   setTimeout(() => { this.finalSizeResolveCheck("font")}, 10);
							 }.bind(this));
						  }
						  break;

			case "font": if(!this._fontOnload){ 
				           //console.log(this.sectionIndex + " final font onload");
						   this._fontOnload = true;
						 }
						break;
			}

			if(this._videoOnload && this._imgOnload && this._styleOnload && this._fontOnload){
				//this.resizeCheck();
				this._allContentOnloadDefer.resolve();
				//console.log(this.sectionIndex + " all content onload");
			}
		}
	}

	videoLoadListeners(){
		this._videos = this.document.querySelectorAll("video");
		this._unloadVideoNum = this._videos.length;
		var video;
		for (var i = 0; i < this._videos.length; i++) {
			video = this._videos[i];
			video.onloadeddata = this.videoOnloadData.bind(this);
			video.onerror = this.videoError.bind(this);
		}
		if(this._unloadVideoNum === 0){
			this.finalSizeResolveCheck("video");
		}
	}

	videoOnloadData(e){
		setTimeout(()=>{
			this.resizeCheck();
			this._unloadVideoNum -= 1;
			this.finalSizeResolveCheck("video");
		}, 1);
	}

	videoError(e){
		console.log(this.sectionIndex + " video["+e.target+"] error !!");
		this.resizeCheck();
		this._unloadVideoNum -= 1;
		this.finalSizeResolveCheck("video");
	}

	/**
	 * Test if images are loaded or add listener for when they load
	 * @private
	 */
	 imageLoadListeners() {
		this._images = this.document.querySelectorAll("img, image");
		var img;

		if(this._rendition._layout.name !== "pre-paginated"){
			this._unloadImgNum = this._images.length;
			for (var i = 0; i < this._images.length; i++) {
				img = this._images[i];
				img.onload = this.imageOnload.bind(this);
				img.onerror = this.imageError.bind(this);
				img.onresize = this.imgResize.bind(this);
			}
			if(this._unloadImgNum === 0){
				this.finalSizeResolveCheck("image");
			}else{
				this.startLoadImage(0);
			}
		}else{
			for (var i = 0; i < this._images.length; i++) {
				img = this._images[i];
				if (typeof img.naturalWidth !== "undefined" && img.naturalWidth === 0) {
					img.onload = this.expand.bind(this);
				}
			}
			this.finalSizeResolveCheck("image");
		}
	}

	startLoadImage(index){
		this._nowLoadIMgIndex = index;
		if(this._images){
			let img = this._images[this._nowLoadIMgIndex];
			$(img).attr($(img).attr("data-img-type"), $(img).attr("data-img-src"));
		}
	}

	imgResize(e){
		//console.log(this.sectionIndex + " img resize !!");
	}

	imageError(e){
		console.log(this.sectionIndex + " img["+$(e.target).attr("data-img-type")+"]["+$(e.target).attr("data-img-src")+"] error !!");
		$(e.target).removeAttr("data-img-src");
		$(e.target).removeAttr("data-img-type");
		$(e.target).removeAttr("style");
		if($(e.target).attr("data-img-style")){
			$(e.target).attr("style", $(e.target).attr("data-img-style"));
			$(e.target).removeAttr("data-img-style");
		}
		this.resizeCheck();
		this._unloadImgNum -= 1;
		this.finalSizeResolveCheck("image");
		if(this._unloadImgNum !== 0){
			this.startLoadImage(this._nowLoadIMgIndex+1);
		}
	}

	imageOnload(e){
		$(e.target).removeAttr("data-img-src");
		$(e.target).removeAttr("data-img-type");
		$(e.target).removeAttr("style");
		if($(e.target).attr("data-img-style")){
			$(e.target).attr("style", $(e.target).attr("data-img-style"));
			$(e.target).removeAttr("data-img-style");
		}
		if(this._rendition._layout.name !== "pre-paginated"){
			this.adjustImageSize(e.target);
		}
		setTimeout(()=>{
			this.resizeCheck();
			this._unloadImgNum -= 1;
			this.finalSizeResolveCheck("image");
			if(this._unloadImgNum !== 0){
				this.startLoadImage(this._nowLoadIMgIndex+1);
			}
		}, 1);
	}

	adjustImageSize(imgElement){
		let columnWidth = this._rendition._layout.columnWidth;
		let computed = this.window.getComputedStyle(this.content, null);
		let height = (this.content.offsetHeight - (parseFloat(computed.paddingTop) + parseFloat(computed.paddingBottom))) * .95;
		let horizontalPadding = parseFloat(computed.paddingLeft) + parseFloat(computed.paddingRight);
		if(columnWidth && this.document){
			let width = columnWidth - horizontalPadding;
			let imgComputedStyle = this.window.getComputedStyle(imgElement, null);
			let containerInfo = this.checkImgContainer(imgElement);
			let minWidth, minHeight, maxWidth;
			let booksWritingMode = this._rendition.themes._booksWritingMode;
			let isfakeImage = false;
			let isFloat = false;
			let isMargin = false;
			let isPadding = false;
			let containerStyle;

			//設定圖片 width, max-width, max-height
			if(containerInfo.containerList.length){
				containerInfo.containerList.forEach((container, index)=>{
					containerStyle = this.window.getComputedStyle(container, null);
					isfakeImage = ($(container).hasClass('books-audio-fake-image') || $(container).hasClass('books-video-fake-image'));
					isFloat = (isFloat || containerStyle.float !== 'none');
					isMargin = (isMargin || containerStyle.margin !== '0px');
					isPadding = (isPadding || containerStyle.padding !== '0px');
				});
				if(!isfakeImage){
					minWidth = Math.min(containerInfo.minInnerWidth, width);
					if(minWidth !=0 && imgElement.width > minWidth){
						$(imgElement).css("width", "100%");
						maxWidth = minWidth;
						$(imgElement).css("max-width", maxWidth);
					}
				}
			}else if(imgComputedStyle.width){
					minWidth = parseInt(imgComputedStyle.width) || 0;
					if(minWidth === 0 || minWidth > width){
						maxWidth = width;
						$(imgElement).css("max-width", maxWidth);
					}
			}else{
				maxWidth = width;
				$(imgElement).css("max-width", maxWidth);
			}

			if(containerInfo.containerList.length){
				containerInfo.containerList.forEach((container, index)=>{
					containerStyle = this.window.getComputedStyle(container, null);
					isfakeImage = ($(container).hasClass('books-audio-fake-image') || $(container).hasClass('books-video-fake-image'));
					isFloat = (isFloat || containerStyle.float !== 'none');
					isMargin = (isMargin || containerStyle.margin !== '0px');
					isPadding = (isPadding || containerStyle.padding !== '0px');
				});
				if(!isfakeImage){
					minHeight = Math.min(containerInfo.minInnerHeight, height);
					if(minHeight !=0 && imgElement.height > minHeight){
						$(imgElement).css("max-height", minHeight);
					}
				}
			}else if(imgComputedStyle.height){
					minHeight = parseInt(imgComputedStyle.height) || 0;
					if(minHeight === 0 || minHeight > height){
						$(imgElement).css("max-height", height);
					}
			}else{
				$(imgElement).css("max-height", height);
			}
		}
	}

	checkImgContainer(targetElement, result){
		let parentElement = $(targetElement).parent();
		let parentTag = parentElement.prop("tagName");
		if(!result){
			result = {
				containerList:[],
				minInnerWidth:null,
				minInnerHeight:null
			}
		}
		if(parentElement.children().length <= 3 && parentTag !== "BODY"){
		
			let conatinerElement = parentElement.get(0);

			if(conatinerElement.style.height == '100vh'){
				conatinerElement.style.height = '';
			}

			let computedStyle = this.window.getComputedStyle(conatinerElement, null);

			//check width
			let width = conatinerElement.clientWidth;
			let borderLeftWidth = parseInt(computedStyle.borderLeftWidth) || 0;
			let borderRightWidth = parseInt(computedStyle.borderRightWidth) || 0;
			let paddingLeft = parseInt(computedStyle.paddingLeft) || 0;
			let paddingRight = parseInt(computedStyle.paddingRight) || 0;
			let innerWidth = width - borderLeftWidth - borderRightWidth - paddingLeft - paddingRight;
			if(result.minInnerWidth === null){
				result.minInnerWidth = innerWidth;
			}else{
				Math.min(result.minInnerWidth, innerWidth);
			}

			//check height
			let height = conatinerElement.clientHeight;
			let borderTopWidth = parseInt(computedStyle.borderTopWidth) || 0;
			let borderBottomWidth = parseInt(computedStyle.borderBottomWidth) || 0;
			let paddingTop = parseInt(computedStyle.paddingTop) || 0;
			let paddingBottom = parseInt(computedStyle.paddingBottom) || 0;
			let innerHeight = height - borderTopWidth - borderBottomWidth - paddingTop - paddingBottom;
			if(result.minInnerHeight === null){
				result.minInnerHeight = innerHeight;
			}else{
				Math.min(result.minInnerHeight, innerHeight);
			}

			//keep container
			result.containerList.unshift(conatinerElement);
			return this.checkImgContainer(conatinerElement, result);
		}else{
			return result;
		}
	}

	/*adjustImgContainerElement(targetElement){
		let parentElement = $(targetElement).parent();
		let parentTag = parentElement.prop("tagName");
		if(parentElement.children().length === 1 && parentTag !== "BODY"){
			let conatinerElement = parentElement.get(0);
			let computedStyle = this.window.getComputedStyle(conatinerElement, null);
			//adjust margin
			let maxMargin = 5;
			let margin = [computedStyle.getPropertyValue("margin-top"), computedStyle.getPropertyValue("margin-right"), computedStyle.getPropertyValue("margin-bottom"), computedStyle.getPropertyValue("margin-left")];
			let newMargin = [];
			let goAdjustMargin = false;
			margin.forEach(marginItem=>{
				if(marginItem === "0px" || marginItem === "0"){
					newMargin.push("0px");
				}else{
					let nowMargin = parseInt(marginItem.replace("px", "").replace("%", ""),10);
					if(nowMargin > maxMargin){
						newMargin.push(`${maxMargin}px`);
						goAdjustMargin = true;
					}else{
						newMargin.push(marginItem);
					}
				}
			});
			if(goAdjustMargin){
				$(conatinerElement).css("margin", newMargin.join(" "));
			}
			return this.adjustImgContainerElement(conatinerElement);
		}
	}*/

	/**
		* Get the height of the text using Range
		* @returns {number} height
		*/
		textHeight() {
			let rect;
			let height;
			let range = this.document.createRange();
			let content = this.content || this.document.body;
	
			range.selectNodeContents(content);
	
			rect = range.getBoundingClientRect();
			height = rect.bottom;

			/*if(this._rendition.settings.isWebtoon && this._rendition.manager.name === "continuous"){
				return Math.floor(height);
			}else{
				return Math.round(height);
			}*/

			if(this._rendition._layout.name === "pre-paginated") {
				if(this._rendition.settings.isWebtoon && !this._rendition._layout._spread && this._rendition.manager.name === "continuous"){
					//條漫單頁滾動瀏覽
					//console.log('contents:條漫單頁滾動瀏覽', height);
					return Math.floor(height);
				}else{
					if(this._rendition.settings.isDomTriggerByTouch){
						//app, mweb
						if(this._rendition.settings.isWebtoon){
							//條漫雙拼, 翻頁模式
							return Math.round(height);
						}else{
							if(this._rendition.manager.name === "continuous"){
								if(!this._rendition._layout._spread){
									//固定版單頁滾動瀏覽
									return Math.floor(height);
								}else{
									//固定版雙拼滾動瀏覽
									return Math.round(height);
								}
							}else{
								//固定版翻頁模式
								return Math.round(height);
							}
						}
					}else{
						//web版
						return Math.round(height);
					}
				}
			}else{
				return Math.round(height);
			}
		}

	/**
	 * Check if size of contents has changed and
	 * emit 'resize' event if it has.
	 * @private
	 */
	resizeCheck(isFinal = false) {
		if(this.document){
			let width = this.textWidth();
			let height = this.textHeight();

			if ((width != this._size.width || height != this._size.height)) {
				this._size = {
					width: width,
					height: height
				};

				this.onResize && this.onResize(this._size);
				this.emit(EVENTS.CONTENTS.RESIZE, this._size);
			}
		}
	}

	/**
	 * Emit passed browser events
	 * @private
	 */
	 triggerEvent(e){
		switch(e.type){
			case "pause":$(e.target).attr("data-is-playing", "no");
						 this.emit(e.type, e);
						 break;

			case "play": $(e.target).attr("data-is-playing", "yes");
						 $(this.document).find("audio,video").not(e.target).each(function(k,v){
							v.pause();
						 });
						 this.emit(e.type, e);
						 break;

			case "webkitbeginfullscreen": this._rendition.manager._isMediaFullScreen = true;
						 				  break;
			case "webkitendfullscreen": this._rendition.manager._isMediaFullScreen = false;
										if(this._rendition._isTriggerSpreadAfterFullScreenEnd){
											this._rendition.settings.spread = this._rendition._spreadAfterFullscreen;
											if (this._rendition._layout) {
												this._rendition._layout.spread(this._rendition._spreadAfterFullscreen, null, false);
											}
											this._rendition._spreadAfterFullscreen = null;
											this._rendition._isTriggerSpreadAfterFullScreenEnd = false;
										}
										if(this._rendition.manager._isTriggerResizeAfterFullScreenEnd){
											this._rendition.manager.afterFullScreenResize();
											this._rendition.manager._isTriggerResizeAfterFullScreenEnd = false;
										}
										break;

			case "webkitfullscreenchange":
			case "mozfullscreenchange":
			case "fullscreenchange": if(!this._rendition.manager.isDocumentFullscreen()){
										if(this._rendition._isTriggerSpreadAfterFullScreenEnd){
											this._rendition.settings.spread = this._rendition._spreadAfterFullscreen;
											if (this._rendition._layout) {
												this._rendition._layout.spread(this._rendition._spreadAfterFullscreen, null, false);
											}
											this._rendition._spreadAfterFullscreen = null;
											this._rendition._isTriggerSpreadAfterFullScreenEnd = false;
										}
										if(this._rendition.manager._isTriggerResizeAfterFullScreenEnd){
											this._rendition.manager.afterFullScreenResize();
											this._rendition.manager._isTriggerResizeAfterFullScreenEnd = false;
										}
									 }else{
										// web 上不會觸發 webkitbeginfullscreen 和 webkitendfullscreen, 所以加入 _isWaitMediaScale 延遲 resize 行為
										if(!this._rendition.manager._isMediaFullScreen){
											this._rendition.manager._isWaitMediaScale = true;
										}
									 }
									 this.emit(e.type, e);
									 break;
			
			case "ended":
			case "error": $(e.target).attr("data-is-playing", "no");
						  this.emit(e.type, e);
						  break;
			
			case "dblclick": //禁止雙擊放大
							 e.stopPropagation();
							 this.emit(e.type, e);
							 break;

			case "touchcancel": //發生觸控取消事件
							    //console.log("touchcancel");
								break;

			case "contextmenu": e.preventDefault();
								if( !this._rendition.settings.disableContextMenu){
									if(this.isContentMenu){
										this.emit(e.type, e);
									}else{
										this.isContentMenu = true;
									}
								}
								return false; 
								break;

			default: this.emit(e.type, e);
		}
	}

	/**
	 * Get the location offset of a EpubCFI or an #id
	 * @param {string | EpubCFI} target
	 * @param {string} [ignoreClass] for the cfi
	 * @returns { {left: Number, top: Number }
	 */
	 locationOf(target, ignoreClass) {
		var position;
		var targetPos = {"left": 0, "top": 0};

		if(!this.document) return targetPos;

		if(this.epubcfi.isCfiString(target)) {
			//置換ExEpubCFI
			let range = new ExEpubCFI(target).toRange(this.document, ignoreClass);
			if(range) {
				try {
					if (!range.endContainer ||
						(range.startContainer == range.endContainer
						&& range.startOffset == range.endOffset)) {
						// If the end for the range is not set, it results in collapsed becoming
						// true. This in turn leads to inconsistent behaviour when calling
						// getBoundingRect. Wrong bounds lead to the wrong page being displayed.
						// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/15684911/
						let pos = range.startContainer.textContent.indexOf(" ", range.startOffset);
						if (pos == -1) {
							pos = range.startContainer.textContent.length;
						}
						range.setEnd(range.startContainer, pos);
					}
				} catch (e) {
					console.error("setting end offset to start container length failed", e);
				}
				if (range.startContainer.nodeType === Node.ELEMENT_NODE) {
					position = range.startContainer.getBoundingClientRect();
					targetPos.left = position.left;
					targetPos.top = position.top;
				} else {
					// Webkit does not handle collapsed range bounds correctly
					// https://bugs.webkit.org/show_bug.cgi?id=138949

					// Construct a new non-collapsed range
					if (isWebkit) {
						let container = range.startContainer;
						let newRange = new Range();
						//因safari的開頭第一個字會誤判到前一頁, 所以用前後各退一個字元的方式調整演算方式
						try {
							if (container.nodeType === ELEMENT_NODE) {
								position = container.getBoundingClientRect();
							} else if (range.startOffset + 2 < container.length) {
								newRange.setStart(container, range.startOffset + 1);
								newRange.setEnd(container, range.startOffset + 2);
								position = newRange.getBoundingClientRect();
							} else if (range.startOffset - 2 > 0) {
								newRange.setStart(container, range.startOffset - 2);
								newRange.setEnd(container, range.startOffset - 1);
								position = newRange.getBoundingClientRect();
							} else { // empty, return the parent element
								position = container.parentNode.getBoundingClientRect();
							}
						} catch (e) {
							console.error(e, e.stack);
						}
					} else {
						position = range.getBoundingClientRect();
					}
				}
			}

		} else if(typeof target === "string" &&
			target.indexOf("#") > -1) {

			let id = target.substring(target.indexOf("#")+1);
			let el = this.document.getElementById(id);
			if(el) {
				if (isWebkit) {
					// Webkit reports incorrect bounding rects in Columns
					let newRange = new Range();
					newRange.selectNode(el);
					position = newRange.getBoundingClientRect();
				} else {
					position = el.getBoundingClientRect();
				}
			}
		}
		if (position) {
			targetPos.left = position.left;
			targetPos.top = position.top;
		}

		return targetPos;
	}

	webToon(columnWidth, height, section, divisor, isFakeWebToon = false){
		var width = columnWidth * divisor;
		columnWidth = (this._rendition._layout._spread) ? width / 2 : width;
		var viewport = this.viewport();
		var viewportWidth = parseInt(viewport.width);
		var viewportHeight = parseInt(viewport.height);
		var webToonWidth = (this._rendition.settings.webtoonMaxWidth) ? Math.min(columnWidth, height, this._rendition.settings.webtoonMaxWidth) : Math.min(columnWidth, height);
		if(isFakeWebToon){
			webToonWidth = columnWidth;
		}
		var scale = webToonWidth / viewportWidth;

		this.layoutStyle("paginated");

		this.width(viewportWidth);
		this.height(viewportHeight);
		this.overflow("visible");

		this.scaler(scale, 0, 0);

		//保留目前 background size
		this._backgroundSize = {
			width:viewportWidth * scale,
			height:viewportHeight * scale
		};
		this.css("background-size", this._backgroundSize.width + "px " + this._backgroundSize.height + "px");

		this.css("background-color", "transparent");

		//var marginTop = (height - (viewportHeight * scale)) / 2;

		this.css("margin-top", "0");
		this.css("margin-bottom", "0");

		if(divisor > 1){			
			var marginLeft;
			if(section && (section.properties.includes("page-spread-center") || section.properties.includes("rendition:page-spread-center"))){
				marginLeft = (width - (viewportWidth * scale)) / 2;
				this.css("margin-left", marginLeft + "px");
				this.css("margin-right", "0");
			}else if (section && (section.properties.includes("page-spread-left") || section.properties.includes("rendition:page-spread-left"))){
				marginLeft = columnWidth - (viewportWidth * scale);
				this.css("margin-left", marginLeft + "px");
				this.css("margin-right", "0");
			}else if(section && (section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right"))){
				this.css("margin-left", "0");
				this.css("margin-right", "0");
			}
		}else{
			var marginHalf = (width - (viewportWidth * scale)) / 2;
			if(section && (section.properties.includes("page-spread-center") || section.properties.includes("rendition:page-spread-center"))){
				this.css("margin-left", marginHalf + "px");
				this.css("margin-right", "0");
			}else if (section && section.properties.includes("page-spread-center-left")){
				if(!this._rendition._layout._spread){
					this.css("margin-left", marginHalf + "px");
				}else{
					this.css("margin-left", Math.max(0, (marginHalf-(viewportWidth * scale/2))) + "px");
				}
				this.css("margin-right", "0");
			}else if(section && section.properties.includes("page-spread-center-right")){
				if(!this._rendition._layout._spread){
					this.css("margin-left", marginHalf + "px");
				}else{
					this.css("margin-left", (marginHalf+(viewportWidth * scale/2)) + "px");
				}
				this.css("margin-right", "0");
			}else if (section && (section.properties.includes("page-spread-left") || section.properties.includes("rendition:page-spread-left"))) {
				this.css("margin-left", marginHalf + "px");
				this.css("margin-right", "0");
			}else if(section && (section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right"))){
				this.css("margin-left", marginHalf + "px");
				this.css("margin-right", "0");
			}
		}

		if(this._videoOnload && this._imgOnload && this._styleOnload && this._fontOnload){
			if(!this._isGetFinalContentSize){
				this._isGetFinalContentSize = true;
				this.resizeCheck();
				this._finalContentSizeDefer.resolve();
				//console.log(this.sectionIndex + "[webToon]", this._size);
			}
			//console.log(this.sectionIndex + " show page");
		}
	}

	/**
	 * Scale contents from center
	 * @param {number} scale
	 * @param {number} offsetX
	 * @param {number} offsetY
	 */
	scaler(scale, offsetX, offsetY, originStr = "top left", firstAction = "scale"){
		var scaleStr = "scale(" + scale + ")";
		var translateStr = "";
		// this.css("position", "absolute"));
		this.css("transform-origin", originStr);

		if ((offsetX >= 0 || typeof offsetX === "string") || offsetY >= 0) {
			if(typeof offsetX === "string"){
				translateStr = " translate( "+offsetX+ ", " + (offsetY || 0 )+ "px )";
			}else{
				translateStr = " translate(" + (offsetX || 0 )+ "px, " + (offsetY || 0 )+ "px )";
			}
		}

		let transformString;
		switch(firstAction){
			case "scale" : transformString = scaleStr + translateStr; break;
			case "translate" : transformString = translateStr + scaleStr; break;
			default : transformString = scaleStr + translateStr;
		}
		this.css("transform", transformString);
	}

	/**
	 * Fit contents into a fixed width and height
	 * @param {number} width
	 * @param {number} height
	 */
	fit(width, height, section, divisor){
		var viewport = this.viewport();
		var viewportWidth = parseInt(viewport.width);
		var viewportHeight = parseInt(viewport.height);
		var widthScale = width / viewportWidth;
		var heightScale = height / viewportHeight;
		var scale = widthScale < heightScale ? widthScale : heightScale;

		var widthScalePoPercent = (((viewportWidth-2) / width - 1) * -100) + '%';
		var heightScalePoPercent = (((viewportHeight-2) / height - 1) * -100) + '%';
		var scalePoPercent = widthScale < heightScale ? widthScalePoPercent : heightScalePoPercent;

		// the translate does not work as intended, elements can end up unaligned
		// var offsetY = (height - (viewportHeight * scale)) / 2;
		// var offsetX = 0;
		// if (this.sectionIndex % 2 === 1) {
		// 	offsetX = width - (viewportWidth * scale);
		// }

		this.layoutStyle("paginated");

		// scale needs width and height to be set
		this.width(viewportWidth);
		this.height(viewportHeight);
		this.overflow("hidden");

		// Scale to the correct size
		if (section && ( section.properties.includes("page-spread-center-left") || section.properties.includes("page-spread-center-right"))){
			if(divisor > 1){
				this.scaler(scale, 0, 0);
			}else{
				if(this._rendition.settings.spread === 'none'){
					this.scaler(scale, 0, 0);
				}else{
					var spWidth = (width / 2) - this._rendition._layout.gap;
					var spWidthScale = spWidth / viewportWidth;
					var spScale = spWidthScale < heightScale ? spWidthScale : heightScale;
					this.scaler(spScale, 0, 0);
				}
			}
		}else{
			if(section && ( section.properties.includes("page-spread-left") || section.properties.includes("rendition:page-spread-left"))){
				// viewport 依目前顯示尺寸縮放時, 會有白色中線的狀況發生, 所以左頁以右側為中心縮放,向左推移後再縮放
				var offsetX = Math.floor(viewportWidth - viewportWidth * scale) ;
				this.scaler(scale, -offsetX, 0, "top right", "translate");
			}else{
				this.scaler(scale, 0, 0);
			}
		}
		// this.scaler(scale, offsetX > 0 ? offsetX : 0, offsetY);

		if(this._rendition._layout.name === "pre-paginated"){
			this.css("overflow", "hidden");
			this.css("background-position", "0");
		}

		// background images are not scaled by transform
		//保留目前 background size
		this._backgroundSize = {
			width:viewportWidth * scale,
			height:viewportHeight * scale
		};
		this.css("background-size", this._backgroundSize.width + "px " + this._backgroundSize.height + "px");

		this.css("background-color", "transparent");

		//fix body margin
		var marginTop;
		if (section && ( section.properties.includes("page-spread-center-left") || section.properties.includes("page-spread-center-right"))){
			if(divisor > 1){
				marginTop = (height - (viewportHeight * scale)) / 2;
			}else{
				if(this._rendition.settings.spread === 'none'){
					marginTop = (height - (viewportHeight * scale)) / 2;
				}else{
					marginTop = (height - (viewportHeight * spScale)) / 2;
				}
			}
		}else{
			marginTop = (height - (viewportHeight * scale)) / 2;
		}
		this.css("margin-top", marginTop+"px");

		this.css("margin-bottom", "0");

		if(divisor > 1){		
			var marginLeft;
			if(section && (section.properties.includes("page-spread-center") || section.properties.includes("rendition:page-spread-center"))){
				marginLeft = (width - (viewportWidth * scale)) / 2;
				this.css("margin-left", marginLeft + "px");
				this.css("margin-right", "0");
			}else if (section && (section.properties.includes("page-spread-left") || section.properties.includes("rendition:page-spread-left"))){
				marginLeft = width - (viewportWidth * scale);
				this.css("margin-left", marginLeft + "px");
				this.css("margin-right", "0");
			}else if(section && (section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right"))){
				this.css("margin-left", "0");
				this.css("margin-right", "0");
			}
		}else{
			var marginHalf = (width - (viewportWidth * scale)) / 2;
			if(section && (section.properties.includes("page-spread-center") || section.properties.includes("rendition:page-spread-center"))){
				this.css("margin-left", marginHalf + "px");
				this.css("margin-right", "0");
			}else if (section && section.properties.includes("page-spread-center-left")){
				if(!this._rendition._layout._spread){
					this.css("margin-left", marginHalf + "px");
				}else{
					this.css("margin-left", Math.max(0, (marginHalf-(viewportWidth * scale/2))) + "px");
				}
				this.css("margin-right", "0");
			}else if(section && section.properties.includes("page-spread-center-right")){
				if(!this._rendition._layout._spread){
					this.css("margin-left", marginHalf + "px");
				}else{
					this.css("margin-left", (marginHalf+(viewportWidth * scale/2)) + "px");
				}
				this.css("margin-right", "0");
			}else if (section && (section.properties.includes("page-spread-left") || section.properties.includes("rendition:page-spread-left"))) {
				this.css("margin-left", marginHalf + "px");
				this.css("margin-right", "0");
			}else if(section && (section.properties.includes("page-spread-right") || section.properties.includes("rendition:page-spread-right"))){
				this.css("margin-left", marginHalf + "px");
				this.css("margin-right", "0");
			}
		}

		if(this._videoOnload && this._imgOnload && this._styleOnload && this._fontOnload){
			if(!this._isGetFinalContentSize){
				this._isGetFinalContentSize = true;
				this.resizeCheck();
				this._finalContentSizeDefer.resolve();
				//console.log(this.sectionIndex + "[fit]", this._size);
			}
			//console.log(this.sectionIndex + " show page");
		}
	}

	/**
	 * Size the contents to a given width and height
	 * @param {number} [width]
	 * @param {number} [height]
	 */
	 size(width, height){
		var viewport = { scale: 1.0, scalable: "no" };

		this.layoutStyle("scrolling");

		if (width >= 0) {
			this.width(width);
			viewport.width = width;
			this.css("padding", "0 "+(width/12)+"px");
		}

		if (height >= 0) {
			this.height(height);
			viewport.height = height;
		}

		this.css("margin", "0");
		this.css("box-sizing", "border-box");

		this.viewport(viewport);

		if(this._imgOnload && this._styleOnload && this._fontOnload){
			if(!this._isGetFinalContentSize){
				this._isGetFinalContentSize = true;
				this.resizeCheck();
				this._finalContentSizeDefer.resolve();
				//console.log(this.sectionIndex + "[size] get final content size ------------------------------------", this._size);
			}
			//console.log(this.sectionIndex + " show page");
		}
	}

	/**
	 * Apply columns to the contents for pagination
	 * @param {number} width
	 * @param {number} height
	 * @param {number} columnWidth
	 * @param {number} gap
	 */
	columns(width, height, columnWidth, gap, dir){
		let COLUMN_AXIS = prefixed("column-axis");
		let COLUMN_GAP = prefixed("column-gap");
		let COLUMN_WIDTH = prefixed("column-width");
		let COLUMN_FILL = prefixed("column-fill");
		
		//增加 columns 屬性以對應 Safari column cut offs 問題
		let COLUMNS = prefixed("columns");

		let writingMode = this.writingMode();
		let axis = (writingMode.indexOf("vertical") === 0) ? "vertical" : "horizontal";

		this.layoutStyle("paginated");

		if (dir === "rtl" && axis === "horizontal") {
			this.direction(dir);
			this.addStylesheetRules({
				"body *" : {
					"direction": "ltr"
				}
			}, "direction");
		}
		this.width(width);
		this.height(height);

		// Deal with Mobile trying to scale to viewport
		this.viewport({ width: width, height: height, scale: 1.0, scalable: "no" });

		// 流動版直書如果body有border會逐頁偏移影響頁面計算,所以加入 border none
		this.css("border", "none");

		// TODO: inline-block needs more testing
		// Fixes Safari column cut offs, but causes RTL issues
		// this.css("display", "inline-block");

		this.css("overflow-y", "hidden");
		this.css("margin", "0", true);

		//讓直書橫書四周padding一致
		this.css("padding-top", (gap / 2) + "px", true);
		this.css("padding-bottom", (gap / 2) + "px", true);
		this.css("padding-left", (gap / 2) + "px", true);
		this.css("padding-right", (gap / 2) + "px", true);

		if (axis === "vertical") {
			this.css(COLUMN_AXIS, "vertical");
			this.css(COLUMNS, "1");
		} else {
			this.css(COLUMN_AXIS, "horizontal");
		}

		this.css("box-sizing", "border-box");
		this.css("max-width", "inherit");

		//在頁面元素都載入後, 為觸發最後一次 render, 所以把之前的屬性都改為 balance, 最後才變成 auto
		if(this._videoOnload && this._imgOnload && this._styleOnload && this._fontOnload){
			this.css(COLUMN_FILL, "auto");
			if(!this._isGetFinalContentSize){
				this._isGetFinalContentSize = true;
				this.resizeCheck();
				this._finalContentSizeDefer.resolve();
				//console.log(this.sectionIndex + "[columns] get final content size ------------------------------------", this._size);
			}
			//console.log(this.sectionIndex + " show page");
		}else{
			this.css(COLUMN_FILL, "balance");
		}

		/*this.css(COLUMN_FILL, "auto");
		console.log(this.sectionIndex + " auto ~~~~~~~~");*/

		this.css(COLUMN_GAP, gap+"px");
		this.css(COLUMN_WIDTH, columnWidth+"px");

		//mweb不支援文字選取
		if(this._rendition.book.settings.encryptType && this._rendition.settings.isDomTriggerByTouch){
			this.css("user-select", "none");
			this.css("-webkit-user-select", "none");
			this.css("-khtml-user-select", "none");
			this.css("-moz-user-select", "none");
			this.css("-moz-user-select", "none");
		}

		// Fix glyph clipping in WebKit
		// https://github.com/futurepress/epub.js/issues/983
		// 會造成safari的行高無作用,所以暫時移除
		// this.css("-webkit-line-box-contain", "block glyphs replaced");
	}

	/**
	 * Set the writingMode of the text
	 * @param {string} [mode="horizontal-tb"] "horizontal-tb" | "vertical-rl" | "vertical-lr"
	 */
	 writingMode(mode) {

		let writingMode = '';

		switch(this._rendition.themes._booksWritingMode){
			case 'initial': let WRITING_MODE = prefixed("writing-mode");
							if (mode && this.documentElement) {
								this.documentElement.style[WRITING_MODE] = mode;
							}
							writingMode = this.window.getComputedStyle(this.content)[WRITING_MODE] || this.window.getComputedStyle(this.documentElement)[WRITING_MODE] ||'';
							break;
			case 'horizontal': writingMode = 'horizontal-tb';
							   break;
			case 'vertical': writingMode = 'vertical-rl';
							 break;
		}
		
		return writingMode;
	}

	/**
	 * Set the direction of the text
	 * @param {string} [dir="ltr"] "rtl" | "ltr"
	 */
	 direction(dir) {
		if (this.documentElement) {
			this.documentElement.style["direction"] = dir;
		}
	}

	/**
	 * Emit event on text selection
	 * @private
	 */
	 triggerSelectedEvent(selection){
		var range, cfirange;

		if (selection && selection.rangeCount > 0) {
			range = selection.getRangeAt(0);
			if(!range.collapsed) {
				// cfirange = this.section.cfiFromRange(range);
				//置換ExEpubCFI
				cfirange = new ExEpubCFI(range, this.cfiBase).toString();
				this.emit(EVENTS.CONTENTS.SELECTED, cfirange);
				this.emit(EVENTS.CONTENTS.SELECTED_RANGE, range);
			}
		}
	}
	/**
	 * set pre select range
	 * @private
	 */
	setPreSelectRange(range){
		this._preSelectRange = range.cloneRange();
	}
	/**
	 * remove pre select range
	 * @private
	 */
	removePreSelectRange(){
		if(this._preSelectRange){
			this._preSelectRange = null;
		}
	}
	/**
	 * Emit event on text selection
	 * @private
	 */
	//加入
	 triggerFinalSelectedEvent(mouseEvent, selection, point = null){
		var range;
		if (selection && selection.rangeCount > 0) {
			range = selection.getRangeAt(0);
			if(!range.collapsed) {

				//置換ExEpubCFI
				let cfi = new ExEpubCFI(range, this.cfiBase);
				let rangeCFI = cfi.toString();

				//修正safari在直書時會因為空白和標點符號而選道上頁的情形
				if(this._rendition.location){
					let selectStartCFI = this.epubcfi.getStartCFIFromRange(rangeCFI);
					let selectEndCFI = this.epubcfi.getEndCFIFromRange(rangeCFI);
					let locationStartCFI = this._rendition.location.start.cfi;
					let locationEndCFI = this._rendition.location.end.cfi;
					let finalStartCFI = (this.epubcfi.compare(selectStartCFI,locationStartCFI) >= 0) ? selectStartCFI : locationStartCFI;
					let finalEndCFI = (this.epubcfi.compare(locationEndCFI,selectEndCFI) >= 0) ? selectEndCFI : locationEndCFI;

					if(finalStartCFI !== selectStartCFI || finalEndCFI !== selectEndCFI){
						rangeCFI = this.epubcfi.getRangeFromStartEndCFI(finalStartCFI, finalEndCFI);
						
						range = this.range(rangeCFI);
						//清空選取範圍
						selection.removeAllRanges();
						selection.addRange(range);
					}
				}

				let cfieven = cfi.getStartCFIFromRange(rangeCFI);
				let summary = range.toString();
				if(summary.replace(/[ ]/g, "").replace(/[\r\n]/g, "") !== ""){
					let isEdit = false;
					if(this._preSelectRange){
						let eeCp = range.compareBoundaryPoints(Range.END_TO_END, this._preSelectRange);
						let esCp = range.compareBoundaryPoints(Range.END_TO_START, this._preSelectRange);
						let seCp = range.compareBoundaryPoints(Range.START_TO_END, this._preSelectRange);
						let ssCp = range.compareBoundaryPoints(Range.START_TO_START, this._preSelectRange);
						isEdit = (eeCp === 0 || esCp === 0 || seCp === 0 || ssCp === 0);
					}
					if(!isEdit && this._rendition.settings.isWakeAppSelectionController){
						let doc = range.startContainer.ownerDocument;
						let startRange = doc.createRange();
						startRange.setStart(range.startContainer, range.startOffset);
						startRange.setEnd(range.startContainer, range.startOffset+1);
						let pos = startRange.getBoundingClientRect();
						let globalPos = this._rendition.conventToGlobalPosition(pos);
						this.emit(EVENTS.CONTENTS.WAKE_SELECTION_CONTROLLER, {viewerX:globalPos.x+pos.width/2, viewerY:globalPos.y+pos.height/2});
					}
					this.emit(EVENTS.CONTENTS.BOOKSSELECTED, mouseEvent, {
						cfi: rangeCFI,
						cfieven: cfieven,
						highlight_text: summary,
						chapter: this._rendition.location.end.label,
						page: `${this._rendition.location.end.index}/${this._rendition.location.end.displayed.page}/${this._rendition.location.end.displayed.total}`,
						spine: this._rendition.location.end.index,
						href: this._rendition.location.end.href,
						isEdit: isEdit
					});
					this.setPreSelectRange(range);
				}
			}
		}
	}

	/**
	 * Get a Dom Range from EpubCFI
	 * @param {EpubCFI} _cfi
	 * @param {string} [ignoreClass]
	 * @returns {Range} range
	 */
	 range(_cfi, ignoreClass){
		 //置換ExEpubCFI
		var cfi = new ExEpubCFI(_cfi);
		return cfi.toRange(this.document, ignoreClass);
	}

	/**
	 * Get an EpubCFI from a Dom Range
	 * @param {Range} range
	 * @param {string} [ignoreClass]
	 * @returns {EpubCFI} cfi
	 */
	 cfiFromRange(range, ignoreClass){
		 //置換ExEpubCFI
		return new ExEpubCFI(range, this.cfiBase, ignoreClass).toString();
	}

	/**
	 * Get an EpubCFI from a Dom node
	 * @param {node} node
	 * @param {string} [ignoreClass]
	 * @returns {EpubCFI} cfi
	 */
	cfiFromNode(node, ignoreClass){
		//置換ExEpubCFI
		return new ExEpubCFI(node, this.cfiBase, ignoreClass).toString();
	}

	// TODO: find where this is used - remove?
	map(layout){
		var map = new ExMapping(layout);
		return map.section();
	}

	mapPage(cfiBase, layout, start, end, dev) {
		var mapping = new ExMapping(layout, dev);
		return mapping.page(this, cfiBase, start, end);
	}

	/**
	 * Remove a class from the contents container
	 * @param {string} removeClass
	 */
	 removeClass(className) {
		var content;

		if(!this.document) return;

		content = this.content || this.document.body;

		if (content) {
			content.classList.remove(className);
			//加入移除link
			$(`link[id='epubjs-inserted-css-${className}']`, this.document).remove();
		}

	}

	/**
	 * Append a stylesheet link to the document head
	 * @param {string} src url
	 */
	 addStylesheet(src, key) {
		return new Promise(function(resolve, reject){
			var $stylesheet;
			var ready = false;

			if(!this.document) {
				resolve(false);
				return;
			}

			// Check if link already exists
			$stylesheet = this.document.querySelector("link[href='"+src+"']");
			if ($stylesheet) {
				resolve(true);
				return; // already present
			}

			$stylesheet = this.document.createElement("link");
			$stylesheet.id = "epubjs-inserted-css-" + (key || '');
			$stylesheet.type = "text/css";
			$stylesheet.rel = "stylesheet";
			$stylesheet.href = src;
			$stylesheet.onload = $stylesheet.onreadystatechange = function() {
				if ( !ready && (!this.readyState || this.readyState == "complete") ) {
					ready = true;
					// Let apply
					setTimeout(() => {
						resolve(true);
					}, 1);
				}
			};

			this.document.head.appendChild($stylesheet);

		}.bind(this)).then(()=>{
			this._unloadStyleNum -= 1;
			this.finalSizeResolveCheck("style");
		});
	}

	/**
	 * Append stylesheet rules to a generate stylesheet
	 * Array: https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet/insertRule
	 * Object: https://github.com/desirable-objects/json-to-css
	 * @param {array | object} rules
	 * @param {string} key If the key is the same, the CSS will be replaced instead of inserted
	 * @param {bool} withOverRideMode
	 */
	 addStylesheetRules(rules, key, withOverRideMode = false) {
		var styleSheet;

		if(!this.document || !rules || rules.length === 0) return;

		// Grab style sheet
		styleSheet = this._getStylesheetNode(key).sheet;

		if(!styleSheet) return;

		if (Object.prototype.toString.call(rules) === "[object Array]") {
			for (var i = 0, rl = rules.length; i < rl; i++) {
				var j = 1, rule = rules[i], selector = rules[i][0], propStr = "";

				//在複寫模式下,刪除舊規則
				if(withOverRideMode){
					let deleteRuleIndex = -1;
					$.each(styleSheet.cssRules, (index, rule) =>{
						if(rule.selectorText === selector){
							deleteRuleIndex = index;
							return false;
						}
					});
					if(deleteRuleIndex >= 0){
						styleSheet.deleteRule(deleteRuleIndex);
					}
				}

				// If the second argument of a rule is an array of arrays, correct our variables.
				if (Object.prototype.toString.call(rule[1][0]) === "[object Array]") {
					rule = rule[1];
					j = 0;
				}

				for (var pl = rule.length; j < pl; j++) {
					var prop = rule[j];
					propStr += prop[0] + ":" + prop[1] + (prop[2] ? " !important" : "") + ";\n";
				}

				// Insert CSS Rule
				styleSheet.insertRule(selector + "{" + propStr + "}", styleSheet.cssRules.length);
			}
		} else {

			const selectors = Object.keys(rules);
			selectors.forEach((selector) => {
				
				//在複寫模式下,刪除舊規則
				if(withOverRideMode){
					let deleteRuleIndex = -1;
					$.each(styleSheet.cssRules, (index, rule) =>{
						if(rule.selectorText === selector){
							deleteRuleIndex = index;
							return false;
						}
					});
					if(deleteRuleIndex >= 0){
						styleSheet.deleteRule(deleteRuleIndex);
					}
				}

				const definition = rules[selector];
				if (Array.isArray(definition)) {
					definition.forEach((item) => {
						const _rules = Object.keys(item);
						const result = _rules.map((rule) => {
							return `${rule}:${item[rule]}`;
						}).join(';');
						styleSheet.insertRule(`${selector}{${result}}`, styleSheet.cssRules.length);
					});
				} else {
					const _rules = Object.keys(definition);
					const result = _rules.map((rule) => {
						return `${rule}:${definition[rule]}`;
					}).join(';');
					styleSheet.insertRule(`${selector}{${result}}`, styleSheet.cssRules.length);
				}
			});
		}
	}

	/**
	 * Handle getting text on selection
	 * @private
	 */
	 onSelectionChange(e){
		if (this.selectionEndTimeout) {
			clearTimeout(this.selectionEndTimeout);
		}
		this.selectionEndTimeout = setTimeout(function() {
			if(this.window){
				var selection = this.window.getSelection();
				this.triggerSelectedEvent(selection);
			}
		}.bind(this), 250);
	}

	destroy() {
		this._images = undefined;
		
		super.destroy();

		this.observer = undefined;

		if (this.selectionEndTimeout) {
			clearTimeout(this.selectionEndTimeout);
			this.selectionEndTimeout = undefined;
		}

		this.window = undefined;
		this.content = undefined;
		this.documentElement = undefined;
		this.document = undefined;
		
		this._rendition = undefined;
		this._finalContentSizeDefer = undefined;
		this._allContentOnloadDefer = undefined;
		this.expanding = undefined; 

	}

}

export default ExContents;